<template>
  <div class="login-main">
    <div class="form-login">
      <a-col :gutter="24" align="center">
        <!-- #d5301e -->
        <a-avatar
          :size="{ xl: 64 }"
          style="background-color: #fff; box-shadow: 5px 5px 10px #fff"
        >
          <template #icon> <img src="@/assets/logo.png" /> </template
        ></a-avatar>
      </a-col>

      <a-col :gutter="24" align="center">
        <h4 style="margin-top: 10px; font-weight: bold; color: deeppink">
          {{ inject("appname") }}
        </h4>
      </a-col>

      <a-form
        :label-col="{ span: 24 }"
        :wrapper-col="{ span: 24 }"
        :model="formData"
        name="normal_login"
        class="login-form"
        label-align="left"
        @finish="login"
      >
        <a-form-item
          label="账户"
          name="username"
          :rules="[{ required: true, message: '账号不能为空!' }]"
        >
          <a-input
            autocomplete="off"
            v-model:value="formData.username"
            size="large"
          >
            <template #prefix>
              <UserOutlined class="site-form-item-icon" />
            </template>
          </a-input>
        </a-form-item>

        <a-form-item
          label="密码"
          name="password"
          :rules="[{ required: true, message: '密码不能为空!' }]"
        >
          <a-input-password
            autocomplete="off"
            v-model:value="formData.password"
            size="large"
          >
            <template #prefix>
              <LockOutlined class="site-form-item-icon" />
            </template>
          </a-input-password>
        </a-form-item>

        <a-form-item>
          <a-button
            :disabled="disabled"
            type="primary"
            danger
            html-type="submit"
            class="login-form-button"
            size="large"
            block
            shape="round"
          >
            <template #icon
              ><LoginOutlined class="site-form-item-icon" />
            </template>
            登入
          </a-button>
        </a-form-item>
        <a-form-item>
          <h5>
            {{ inject("version") }}<br />技术支持：{{ inject("company") }}
          </h5>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed, inject } from "vue";
import {
  UserOutlined,
  LockOutlined,
  LoginOutlined,
} from "@ant-design/icons-vue";
import jaxios from "@/request/http";
import { message } from "ant-design-vue";
import router from "@/router";
import NormalUtil from "@/unit/normalUtil";

const formData = reactive({
  username: "18163799211",
  password: "",
});

const disabled = computed(() => {
  if (formData.username == "" || formData.password == "") {
    return true;
  }
  return false;
});

const login = () => {
  jaxios
    .post("/login/auth", formData)
    .then((response) => {
      NormalUtil.RRM(response, function () {
        localStorage.setItem("token", response.data.data.access_token);
        localStorage.setItem("username", response.data.data.username);
        localStorage.setItem("name", response.data.data.name);
        localStorage.setItem("userid", response.data.data.userid);
        message.success("登入成功！");
        router.push("/admin");
      });
    })
    .catch((error) => {
      NormalUtil.DARE(error);
    });
};
</script>

<style scoped lang="scss">
.videoBG {
  //position: fixed;
  //bottom: 0;
  //left: 50%;
  //transform: translateX(-50%);
  //width: 100%;
  //height: 30%;
  //object-fit: cover;
  //z-index: -1;
  position: fixed;
  top: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  object-fit: cover;
  z-index: -1;
  transform: translateZ(0);
  backface-visibility: hidden;
}
body {
  margin: 0;
  overflow: hidden;
}
html {
  height: 100%;
  width: 100%;
}
.form-login {
  max-width: 477px;
  padding: 40px;
  margin: auto;
  text-align: left;
  //background-color: #b0d3f6; 5330b0  , rgba(232, 223, 255, 0.5);
  // background-color: rgba(183, 157, 252, 0.2);
  background-color: rgba(255, 255, 255, 0.2);
  //5234b0
  color: #fff;
  opacity: 1;
  border-radius: 6px;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  position: absolute;
}

.form-login .form-floating:focus-within {
  z-index: 2;
}

.form-login input[type="text"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-color: #198754;
}

.form-login input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-color: #198754;
}

.ant-form-item {
  text-align: right;
}

::v-deep(.ant-form-item-label) label {
  color: white !important;
}

/* 确保输入框边框颜色与背景协调 */
.ant-form-item-explain {
  color: #ff4d4f !important;
}

.ant-input:focus {
  caret-color: white;
}
</style>
